<template>
    <div v-if="object" class="order-grid">
        <div class="order-grid--col">
            <div class="delivery-data">
                <div class="delivery-data--row">
                    <div class="delivery-data--row--header">
                        Zvoľte dopravu
                    </div>
                
                    <div class="form form-row-tight">
                        <DataItem v-for="item in object.deliveryMethods" :key="item.id" :error="object.errors && object.errors.delivery_method_id ? true : false" :subError="object.errors && object.errors.parcel_service ? true : false" :subErrorMessage="object.errors && object.errors.parcel_service ? object.errors.parcel_service[0] : null" :item="item" type="delivery" :selected="object.cart.delivery_method_id" :selectedParcelService="object.cart.parcel_service ? object.cart.parcel_service.parcel : null" @update="object.cart.delivery_method_id = $event" @updateParcelService="updateParcelService( $event )" />

                        <div v-if="object.errors && object.errors.delivery_method_id" class="form--box box-span-2">
                            <div class="form--box--error">
                                {{ object.errors.delivery_method_id[0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="delivery-data--row">    
                    <div class="delivery-data--row--header">
                        Zvoľte platbu
                    </div>
                
                    <div class="form form-row-tight">
                        <DataItem v-for="item in object.paymentMethods" :key="item.id" :error="object.errors && object.errors.payment_method_id ? true : false" :item="item" type="payment" :selected="object.cart.payment_method_id" @update="object.cart.payment_method_id = $event" />

                        <div v-if="object.errors && object.errors.payment_method_id" class="form--box box-span-2">
                            <div class="form--box--error">
                                {{ object.errors.payment_method_id[0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="delivery-data--row">
                    <div class="order-actions">
                        <div class="order-actions--col">
                            <a :href="backUrl" class="btn btn-text-action-blue btn-text-small btn-icon-left icon-prev">Späť</a>
                        </div>
        
                        <div class="order-actions--col col-center">
                            <span class="btn btn-action-red btn-padding-big" @click="continueOnCompletion()">Odoslať objednávku</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="order-grid--col">
            <CartSummary :cart="object.cart" @update="loadCart()" />

            <div class="order-actions">
                <div class="order-actions--col">
                    <a :href="backUrl" class="btn btn-text-action-blue btn-text-small btn-icon-left icon-prev">Späť</a>
                </div>

                <div class="order-actions--col col-center">
                    <span class="btn btn-action-red btn-padding-big" @click="continueOnCompletion()">Odoslať objednávku</span>
                </div>
            </div>
        </div>
    </div>

    <CompletionPopup v-if="showCompletionPopup" :cart="object.cart" @closeCompletionPopup="showCompletionPopup = false" @setCartPriceRounding="object.cart.price_rounding = $event" />
</template>

<script>
    import CartSummary from './summary/CartSummary'
    import DataItem from './payment/DataItem'
    import CompletionPopup from '../popups/CompletionPopup'
    
    export default {
        components: {
            CartSummary,
            DataItem,
            CompletionPopup
        },
        props: {
            logged_user_id: {
                type: Number
            },
            backUrl: {
                type: String
            }
        },
        data() {
            return {
                object: null,
                showCompletionPopup: false
            }
        },
        created() {
            this.loadCart()
        },
        methods: {
            loadCart() {
                axios.post('/api/shop/cart/payment', {user_id: this.logged_user_id})
                .then( response => {

                    this.object = response.data.object
    
                }).catch( errors => { console.log( errors.response.data.errors ) })
            },
            continueOnCompletion() {
                axios.post('/api/shop/cart/payment/continue', this.object.cart)
                .then( response => {

                    this.object.cart.rounding = response.data.rounding
                    this.object.errors = null
                    this.showCompletionPopup = true
    
                }).catch( errors => { this.object.errors = errors.response.data.errors })
            },
            updateParcelService( service ) {
                this.object.cart.parcel_service = {
                    service: service
                }

                axios.post(`/api/shop/cart/${this.object.cart.id}/update-parcel-service`, this.object.cart)
                .then( response => { 
                    if ( response.data.status ) this.object.cart = response.data.object.cart
                }).catch( errors => { 
                    this.object.cart.parcel_service = null
                    alert('Woops, nepodarilo sa načítať dáta!') 
                })
            }
        },
        watch: {
            'object.cart.delivery_method_id': {
                handler: function ( value, oldValue ) {
                    if ( value && value !== oldValue ) {
                        axios.post(`/api/shop/cart/${this.object.cart.id}/update-delivery-method`, this.object.cart)
                        .then( response => { 
                            if ( response.data.status ) this.object = response.data.object
                        })
                        .catch( errors => { alert('Woops, nepodarilo sa načítať dáta!') })
                    }
                },
                deep: true
            },
            'object.cart.payment_method_id': {
                handler: function ( value, oldValue ) {
                    if ( value && value !== oldValue ) {
                        axios.post(`/api/shop/cart/${this.object.cart.id}/update-payment-method`, this.object.cart)
                        .then( response => { 
                            if ( response.data.status ) this.object = response.data.object
                        })
                        .catch( errors => { alert('Woops, nepodarilo sa načítať dáta!') })
                    }
                },
                deep: true
            }
        }
    }
</script>